/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.card-padding[_ngcontent-%COMP%]{padding-top:15px}.content-padding[_ngcontent-%COMP%]{padding:0 30px 0 30px}.action-margin[_ngcontent-%COMP%]{margin-bottom:0}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL2JyYW5jaC9jb21wb25lbnQvYnJhbmNoLWNyZWF0ZS11cGRhdGUvYnJhbmNoLWNyZWF0ZS11cGRhdGUuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9icmFuY2gvY29tcG9uZW50L2JyYW5jaC1jcmVhdGUtdXBkYXRlL2JyYW5jaC1jcmVhdGUtdXBkYXRlLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/branch/component/branch-create-update/branch-create-update.component.css.shim.ngstyle.ts